import {lidIsFullyCoveredByManhole} from "../../../containers/domain/lid";
import {getLidOpeningsArrangementMessages} from "./manholeArrangement";
import type {Plan} from "types";
import type {ValidationMessage} from "../../types";
import {getManholeOpeningDirectionErrorMessages} from "./manholeOpeningDirection";
import {getManholeCountErrorMessages} from "./manholeCount";

export const validate = (plan: Plan): ValidationMessage[] => {
    const standardLidOptimizationMessages = (): ValidationMessage[] => {
        if (!plan.lid) return [];
        if (plan.lid.type !== "D400" && plan.lid.type !== "E600") return [];
        const hasOneManhole = () => plan.lid.manholes.length === 1;
        const manhole = () => (hasOneManhole() ? plan.lid.manholes[0] : null);
        const isFullyCoveredByManhole = () => lidIsFullyCoveredByManhole(plan);
        const couldBeCoveredByMove = () =>
            manhole()!.orientation === "vertical"
                ? plan.length <= manhole()!.width && plan.width <= manhole()!.height
                : plan.width <= manhole()!.height && plan.length <= manhole()!.width;
        const couldBeCoveredByReasonableResize = () =>
            manhole()!.orientation === "vertical"
                ? plan.length <= manhole()!.width + 52 && plan.width <= manhole()!.height + 10
                : plan.width <= manhole()!.height + 52 && plan.length <= manhole()!.width + 10;

        return !hasOneManhole() || isFullyCoveredByManhole()
            ? []
            : couldBeCoveredByMove()
                ? [
                    {
                        message:
                            "Optimierungsvorschlag: Damit eine Standardabdeckung verwendet werden kann, muss das" +
                            " Lichtmass des Kabelschachtes komplett durch die Einstiegsöffnung abgedeckt sein." +
                            "\nVerschieben Sie die Position der Einstiegsöffnung.",
                        severity: "info",
                    },
                ]
                : couldBeCoveredByReasonableResize()
                    ? [
                        {
                            message:
                                "Optimierungsvorschlag: Damit eine Standardabdeckung verwendet werden kann, muss das" +
                                " Lichtmass des Kabelschachtes komplett durch die Einstiegsöffnung abgedeckt sein." +
                                "\nÄndern Sie ggf. die Abmessung (Länge/Breite im Licht) oder die Grösse der" +
                                " Einstiegsöffnung (allenfalls Wandüberlappung erforderlich).",
                            severity: "info",
                            resolveLocation: "/step/1",
                            resolveLocationText: "Zu Schritt 1",
                        },
                    ]
                    : [];


    }

    const validateManholesArrangement = (): ValidationMessage[] =>
        getLidOpeningsArrangementMessages(plan, {severity: 'error'});

    const validateOpeningDirections = (): ValidationMessage[] =>
        getManholeOpeningDirectionErrorMessages(plan, {severity: 'error'})

    const validateManholeCount = (): ValidationMessage[] =>
        getManholeCountErrorMessages(plan, {severity: 'error'})


    return [
        ...standardLidOptimizationMessages(),
        ...validateManholesArrangement(),
        ...validateOpeningDirections(),
        ...validateManholeCount()
    ];
};
